import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24ea38ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal-el",
  ref: "childComponentRef"
}
const _hoisted_2 = { class: "modal-body scroll-y mh-650px bg-opacity-50 bg-light width-850" }
const _hoisted_3 = {
  class: "nav nav-tabs",
  role: "tablist"
}
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = {
  class: "nav-link active",
  ref: "detailTab",
  "data-bs-toggle": "tab",
  href: "#details"
}
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = {
  class: "nav-link",
  ref: "noteTab",
  "data-bs-toggle": "tab",
  href: "#notes"
}
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = {
  class: "nav-link",
  "data-bs-toggle": "tab",
  ref: "conversationTab",
  href: "#conversation"
}
const _hoisted_10 = { class: "tab-content bg-white" }
const _hoisted_11 = {
  id: "details",
  class: "container tab-pane tab-height active"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "fv-row mb-3" }
const _hoisted_14 = { class: "fs-6 required mb-2" }
const _hoisted_15 = { class: "fv-plugins-message-container text-start" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "fv-row mb-3" }
const _hoisted_18 = { class: "fs-6 required mb-2" }
const _hoisted_19 = { class: "fv-plugins-message-container text-start" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "fv-row mb-3" }
const _hoisted_22 = { class: "fs-6 required mb-2" }
const _hoisted_23 = { class: "fv-plugins-message-container text-start" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "row row-cols-lg-2 g-10" }
const _hoisted_26 = { class: "col" }
const _hoisted_27 = { class: "fv-row mb-3" }
const _hoisted_28 = { class: "fs-6 required mb-2 required" }
const _hoisted_29 = { class: "fv-plugins-message-container text-start" }
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = {
  class: "col",
  "data-kt-calendar": "datepicker"
}
const _hoisted_32 = { class: "fv-row mb-3" }
const _hoisted_33 = { class: "fs-6 required mb-2" }
const _hoisted_34 = { class: "fv-plugins-message-container text-start" }
const _hoisted_35 = {
  class: "fv-help-block",
  ref: "codeError"
}
const _hoisted_36 = {
  id: "notes",
  class: "container tab-pane fade"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = { class: "fv-row mb-3" }
const _hoisted_39 = { class: "text-end" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Add Note ")
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = {
  class: "modal",
  id: "addNote"
}
const _hoisted_44 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_45 = { class: "modal-content" }
const _hoisted_46 = { class: "modal-header" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "modal-title" }, "Add Note", -1))
const _hoisted_48 = { class: "modal-body scroll-y mh-650px bg-opacity-50 bg-light" }
const _hoisted_49 = { class: "mb-2" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Note", -1))
const _hoisted_51 = { class: "fv-plugins-message-container text-start" }
const _hoisted_52 = {
  class: "fv-help-block",
  ref: "codeError"
}
const _hoisted_53 = { class: "modal-footer d-flex justify-content-between" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
  type: "submit"
}, " Add ", -1))
const _hoisted_55 = { class: "my-2 bg-white" }
const _hoisted_56 = { class: "table align-middle table-hover table-row-bordered fs-6 gy-3 kt_data_table tab-height" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bold text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "User"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Notes"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center min-w-125px" }, "Actions")
  ])
], -1))
const _hoisted_58 = { class: "text-gray-600 fw-bold" }
const _hoisted_59 = { class: "wrap-note" }
const _hoisted_60 = { class: "text-center" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1))
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = ["onClick"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = {
  id: "conversation",
  class: "container tab-pane fade"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_69 = { class: "text-end" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-link" }, null, -1))
const _hoisted_71 = /*#__PURE__*/_createTextVNode()
const _hoisted_72 = /*#__PURE__*/_createTextVNode("Link Chat")
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_74 = /*#__PURE__*/_createTextVNode()
const _hoisted_75 = /*#__PURE__*/_createTextVNode("Add Chat")
const _hoisted_76 = { class: "row mb-3" }
const _hoisted_77 = { class: "my-2 bg-white" }
const _hoisted_78 = { class: "table align-middle table-hover table-row-bordered fs-6 gy-3 kt_data_table tab-height" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bold text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Participants"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Last Updated"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center min-w-125px" }, "Action")
  ])
], -1))
const _hoisted_80 = { class: "text-gray-600 fw-bold" }
const _hoisted_81 = { class: "symbol-group symbol-hover" }
const _hoisted_82 = {
  key: 0,
  class: "symbol symbol-30px symbol-circle",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": "Ali Treen"
}
const _hoisted_83 = { class: "symbol-label bg-warning text-inverse-warning fw-bolder" }
const _hoisted_84 = {
  key: 0,
  class: "symbol symbol-30px symbol-circle",
  "data-bs-toggle": "modal",
  "data-bs-target": "#viewUsers"
}
const _hoisted_85 = { class: "symbol-label bg-dark text-gray-300 fs-8 fw-bolder" }
const _hoisted_86 = { class: "text-center" }
const _hoisted_87 = ["aria-readonly", "onClick"]
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chat-left-text fs-4" }, null, -1))
const _hoisted_89 = [
  _hoisted_88
]
const _hoisted_90 = ["onClick"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1))
const _hoisted_92 = [
  _hoisted_91
]
const _hoisted_93 = ["onClick"]
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_95 = [
  _hoisted_94
]
const _hoisted_96 = { class: "modal-footer d-flex justify-content-between" }
const _hoisted_97 = ["disabled"]
const _hoisted_98 = { class: "indicator-label" }
const _hoisted_99 = ["disabled"]
const _hoisted_100 = { class: "indicator-label" }
const _hoisted_101 = { class: "indicator-progress" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_103 = { class: "modal-body scroll-y mh-650px bg-opacity-50 bg-light" }
const _hoisted_104 = { class: "tab-content bg-white" }
const _hoisted_105 = {
  id: "notedetails",
  class: "container tab-pane active tab-height"
}
const _hoisted_106 = { class: "modal-footer d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Form = _resolveComponent("Form")!
  const _component_lable = _resolveComponent("lable")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!
  const _component_AddEditModal = _resolveComponent("AddEditModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showDialog)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.showDialog,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.showDialog) = $event)),
          title: _ctx.modalTitle,
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "destroy-on-close": true,
          onClose: _ctx.hideDialog
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Form, {
              id: "kt_add_event_modal",
              onSubmit: _ctx.submitScheduleData,
              ref: "scheduleFormRef",
              class: "form",
              "validation-schema": _ctx.scheduleFormData.validationSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("ul", _hoisted_3, [
                    _createElementVNode("li", _hoisted_4, [
                      _createElementVNode("a", _hoisted_5, "Details", 512)
                    ]),
                    _createElementVNode("li", _hoisted_6, [
                      _createElementVNode("a", _hoisted_7, "Notes", 512)
                    ]),
                    _createElementVNode("li", _hoisted_8, [
                      _createElementVNode("a", _hoisted_9, "Chat", 512)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.translate("common.site")), 1),
                        _createVNode(_component_Field, {
                          name: "site",
                          modelValue: _ctx.targetData['siteId'],
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetData['siteId']) = $event))
                        }, {
                          default: _withCtx(({ handleChange, value }) => [
                            _createVNode(_component_el_select, {
                              disabled: _ctx.formDisabled,
                              "default-first-option": "",
                              modelValue: value,
                              "onUpdate:modelValue": handleChange,
                              onChange: _ctx.siteUpdated,
                              filterable: "",
                              placeholder: _ctx.t('common.site')
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites, (option, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: option.name,
                                    value: option.webId
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "onChange", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_ErrorMessage, { name: "site" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate("common.usersRoles")), 1),
                        _createVNode(_component_Field, {
                          name: "user",
                          modelValue: _ctx.targetData['userAccountId'],
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.targetData['userAccountId']) = $event))
                        }, {
                          default: _withCtx(({ handleChange, value }) => [
                            _createVNode(_component_el_select, {
                              "default-first-option": "",
                              modelValue: value,
                              "onUpdate:modelValue": handleChange,
                              onChange: _ctx.userUpdated,
                              filterable: "",
                              disabled: _ctx.formDisabled,
                              placeholder: _ctx.t('common.usersRoles')
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (option, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: option.label,
                                    value: option.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "disabled", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_ErrorMessage, { name: "user" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.translate("common.form")), 1),
                        _createVNode(_component_Field, {
                          name: "form",
                          modelValue: _ctx.targetData['formDefinitionId'],
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetData['formDefinitionId']) = $event))
                        }, {
                          default: _withCtx(({ handleChange, value }) => [
                            _createVNode(_component_el_select, {
                              "default-first-option": "",
                              modelValue: value,
                              "onUpdate:modelValue": handleChange,
                              filterable: "",
                              disabled: _ctx.formDisabled,
                              placeholder: _ctx.t('common.form')
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forms, (option, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: option.label,
                                    value: option.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_ErrorMessage, { name: "form" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate("common.startDate")), 1),
                            _createVNode(_component_Field, {
                              name: "startDate",
                              modelValue: _ctx.targetData['startDate'],
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.targetData['startDate']) = $event))
                            }, {
                              default: _withCtx(({ field }) => [
                                _createVNode(_component_el_date_picker, _mergeProps(field, {
                                  type: "datetime",
                                  disabled: _ctx.formDisabled,
                                  "value-format": "YYYY-MM-DD HH:mm",
                                  format: _ctx.displayDateTime,
                                  placeholder: `${_ctx.t('common.startDateAndTime')}`,
                                  modelValue: _ctx.targetData['startDate'],
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.targetData['startDate']) = $event)),
                                  name: "startDate",
                                  class: "w-100",
                                  disabledDate: _ctx.disablePreviousDates
                                }), null, 16, ["disabled", "format", "placeholder", "modelValue", "disabledDate"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createVNode(_component_ErrorMessage, { name: "startDate" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.translate("common.endDate")), 1),
                            _createVNode(_component_Field, {
                              name: "endDate",
                              modelValue: _ctx.targetData['endDate'],
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.targetData['endDate']) = $event))
                            }, {
                              default: _withCtx(({ field }) => [
                                _createVNode(_component_el_date_picker, _mergeProps(field, {
                                  type: "datetime",
                                  disabled: _ctx.formDisabled,
                                  "value-format": "YYYY-MM-DD HH:mm",
                                  format: _ctx.displayDateTime,
                                  placeholder: `${_ctx.t('common.endDateAndTime')}`,
                                  modelValue: _ctx.targetData['endDate'],
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.targetData['endDate']) = $event)),
                                  name: "endDate",
                                  class: "w-100",
                                  disabledDate: _ctx.disablePreviousDates
                                }), null, 16, ["disabled", "format", "placeholder", "modelValue", "disabledDate"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                _createVNode(_component_ErrorMessage, { name: "endDate" })
                              ], 512)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("a", {
                            class: _normalizeClass(["btn btn-outline btn-outline-primary btn-active-light-primary min-w-90p", 
                      (_ctx.targetData['scheduleStatus'] &&
                        _ctx.targetData['scheduleStatus'] != 'SCHEDULE') ||
                      (_ctx.targetData['status'] &&
                        _ctx.targetData['status'] === 'IN_PROGRESS')
                        ? 'disableClick'
                        : ''
                    ]),
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#addNote"
                          }, _hoisted_42, 2)
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _hoisted_47,
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clearNote && _ctx.clearNote(...args))),
                                  class: "btn-close",
                                  "data-bs-dismiss": "modal",
                                  ref: "noteCloseButtonRef"
                                }, null, 512)
                              ]),
                              _createVNode(_component_Form, {
                                id: "kt_add_event_modal",
                                onSubmit: _ctx.saveNote,
                                ref: "noteFormRef",
                                class: "form",
                                "validation-schema": _ctx.noteValidationSchema
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("div", _hoisted_49, [
                                      _hoisted_50,
                                      _createVNode(_component_Field, {
                                        name: "note",
                                        modelValue: _ctx.noteData,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.noteData) = $event))
                                      }, {
                                        default: _withCtx(({ field }) => [
                                          _createVNode(_component_el_input, _mergeProps(field, {
                                            name: "note",
                                            modelValue: _ctx.noteData,
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.noteData) = $event)),
                                            type: "textarea",
                                            rows: "5",
                                            placeholder: "Enter note"
                                          }), null, 16, ["modelValue"])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"]),
                                      _createElementVNode("div", _hoisted_51, [
                                        _createElementVNode("div", _hoisted_52, [
                                          _createVNode(_component_ErrorMessage, { name: "note" })
                                        ], 512)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_53, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.clearNote && _ctx.clearNote(...args))),
                                      class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                                      "data-bs-dismiss": "modal"
                                    }, _toDisplayString(_ctx.t("common.close")), 1),
                                    _hoisted_54
                                  ])
                                ]),
                                _: 1
                              }, 8, ["onSubmit", "validation-schema"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("table", _hoisted_56, [
                            _hoisted_57,
                            _createElementVNode("tbody", _hoisted_58, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes, (note, index) => {
                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                  _createElementVNode("td", null, _toDisplayString(note.date), 1),
                                  _createElementVNode("td", null, _toDisplayString(note.user), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_59, _toDisplayString(note.text), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_60, [
                                    _createElementVNode("a", {
                                      class: "btn btn-icon btn-primary btn-circle btn-sm",
                                      onClick: ($event: any) => (_ctx.showNoteDetails(note))
                                    }, _hoisted_63, 8, _hoisted_61),
                                    _createElementVNode("a", {
                                      class: "btn btn-icon btn-danger btn-circle btn-sm ms-2",
                                      onClick: ($event: any) => (_ctx.deleteNote(note))
                                    }, _hoisted_66, 8, _hoisted_64)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _hoisted_68,
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("a", {
                          class: _normalizeClass([
                    (_ctx.targetData['scheduleStatus'] &&
                      _ctx.targetData['scheduleStatus'] != 'SCHEDULE') ||
                    (_ctx.targetData['status'] &&
                      _ctx.targetData['status'] === 'IN_PROGRESS')
                      ? 'disableClick'
                      : ''
                  , "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px"]),
                          style: {"margin-right":"10px"},
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openLinkConversationDialog()))
                        }, [
                          _hoisted_70,
                          _hoisted_71,
                          _createVNode(_component_lable, null, {
                            default: _withCtx(() => [
                              _hoisted_72
                            ]),
                            _: 1
                          })
                        ], 2),
                        _createElementVNode("a", {
                          class: _normalizeClass([
                    (_ctx.targetData['scheduleStatus'] &&
                      _ctx.targetData['scheduleStatus'] != 'SCHEDULE') ||
                    (_ctx.targetData['status'] &&
                      _ctx.targetData['status'] === 'IN_PROGRESS')
                      ? 'disableClick'
                      : ''
                  , "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px"]),
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openConversationDialog()))
                        }, [
                          _hoisted_73,
                          _hoisted_74,
                          _createVNode(_component_lable, null, {
                            default: _withCtx(() => [
                              _hoisted_75
                            ]),
                            _: 1
                          })
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("table", _hoisted_78, [
                            _hoisted_79,
                            _createElementVNode("tbody", _hoisted_80, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conversations, (conv, index) => {
                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                  _createElementVNode("td", null, _toDisplayString(conv.title), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_81, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conv.participants, (part, indexx) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, { key: indexx }, [
                                          (!part.deleted)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                                _createElementVNode("span", _hoisted_83, _toDisplayString(part.firstName[0]), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128)),
                                      (conv.participants.length > 5)
                                        ? (_openBlock(), _createElementBlock("a", _hoisted_84, [
                                            _createElementVNode("span", _hoisted_85, "+" + _toDisplayString(conv.participants.length - 5), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(conv.updateDate
                                ? _ctx.FormatMethods.DateTime(conv.updateDate)
                                : ""), 1),
                                  _createElementVNode("td", _hoisted_86, [
                                    (conv.webId && !conv.linked)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          class: "btn btn-icon btn-info btn-circle btn-sm",
                                          "aria-readonly": !conv.webId,
                                          onClick: ($event: any) => (_ctx.toggleChat(conv.webId))
                                        }, _hoisted_89, 8, _hoisted_87))
                                      : _createCommentVNode("", true),
                                    (!conv.linked)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          onClick: ($event: any) => (_ctx.editConversation(conv, index)),
                                          class: "btn btn-icon btn-primary btn-circle btn-sm ms-2"
                                        }, _hoisted_92, 8, _hoisted_90))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("a", {
                                      onClick: ($event: any) => (_ctx.deleteConversation(conv, index)),
                                      class: "btn btn-icon btn-danger btn-circle btn-sm ms-2"
                                    }, _hoisted_95, 8, _hoisted_93)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_96, [
                  _createElementVNode("button", {
                    type: "reset",
                    ref: "closeButtonRef",
                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.discard && _ctx.discard(...args))),
                    class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px"
                  }, _toDisplayString(_ctx.translate("common.close")), 513),
                  _createElementVNode("div", null, [
                    (
                _ctx.modalTitle !== _ctx.translate('common.addTask') &&
                _ctx.hasPermission('VYZOR:APPLICATIONS:SCHEDULER:DELETE')
              )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          disabled: 
                (_ctx.targetData['scheduleStatus'] &&
                  _ctx.targetData['scheduleStatus'] != 'SCHEDULE') ||
                (_ctx.targetData['status'] && _ctx.targetData['status'] === 'IN_PROGRESS')
              ,
                          id: "delete_event",
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleDelete && _ctx.handleDelete(...args))),
                          class: "btn btn-outline btn-outline-danger btn-active-light-danger min-w-90px"
                        }, [
                          _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.translate("common.delete")), 1)
                        ], 8, _hoisted_97))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "submit",
                      id: "add_event_submit",
                      disabled: 
                (_ctx.targetData['scheduleStatus'] &&
                  _ctx.targetData['scheduleStatus'] != 'SCHEDULE') ||
                (_ctx.targetData['status'] && _ctx.targetData['status'] === 'IN_PROGRESS')
              ,
                      class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px"
                    }, [
                      _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.translate("common.save")), 1),
                      _createElementVNode("span", _hoisted_101, [
                        _createTextVNode(_toDisplayString(_ctx.translate("common.pleaseWait")) + " ", 1),
                        _hoisted_102
                      ])
                    ], 8, _hoisted_99)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ]),
          _: 1
        }, 8, ["modelValue", "title", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showNotesDetail,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showNotesDetail) = $event)),
      title: `Notes`,
      "close-on-click-modal": false,
      "destroy-on-close": true,
      onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showNotesDetail = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_103, [
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.selectedNote.text), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_106, [
          _createElementVNode("button", {
            type: "reset",
            ref: "closeButtonRef",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showNotesDetail = false)),
            class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px"
          }, _toDisplayString(_ctx.translate("common.close")), 513)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_VZDeleteModal, {
      viewName: "scheduler-task",
      selectedForAction: _ctx.targetData,
      deleteText: `${_ctx.t('validation.sureToDelete')} current task ?`,
      onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showDeleteDialog = false)),
      showDialog: _ctx.showDeleteDialog,
      onBulkDelete: _ctx.onTaskDelete
    }, null, 8, ["selectedForAction", "deleteText", "showDialog", "onBulkDelete"]),
    _createVNode(_component_AddEditModal, {
      viewName: "conversationEdit",
      data: _ctx.formData,
      onOnSubmit: _ctx.submitConversationData,
      onOnCancel: _cache[20] || (_cache[20] = ($event: any) => (_ctx.addConvDialog = false)),
      onOnClose: _cache[21] || (_cache[21] = ($event: any) => (_ctx.addConvDialog = false)),
      modelValue: _ctx.addConvDialog,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.addConvDialog) = $event))
    }, null, 8, ["data", "onOnSubmit", "modelValue"]),
    _createVNode(_component_AddEditModal, {
      viewName: "linkconversationEdit",
      data: _ctx.linkFormData,
      onOnSubmit: _ctx.submitLinkConversationData,
      onOnCancel: _cache[23] || (_cache[23] = ($event: any) => (_ctx.linkConvDialog = false)),
      onOnClose: _cache[24] || (_cache[24] = ($event: any) => (_ctx.linkConvDialog = false)),
      modelValue: _ctx.linkConvDialog,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.linkConvDialog) = $event))
    }, null, 8, ["data", "onOnSubmit", "modelValue"])
  ], 512))
}